import firebase from "firebase/app";

const state = {
  user: null,
  error: null
};

const getters = {
  getUser(state) {
    return state.user;
  },
  getUserId(state) {
    return state.user.uid;
  },
  isUserAuth(state) {
    return !!state.user;
  },
  getErrorAuth(state) {
    return state.error;
  }
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setError(state, payload) {
    state.error = payload;
  }
};

const actions = {
  authAction({ commit }) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        commit("setUser", user);
      } else {
        commit("setUser", null);
      }
    });
  },
  isAuth() {
    if (this.isUserAuth) {
      return true;
    } else {
      return false;
    }
  },
  async signInAction({ commit }, payload) {
    await firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(response => {
        commit("setUser", response.user);
      })
      .catch(error => {
        commit("setError", error.message);
      });

    const user = firebase.auth().currentUser;
    const doctor = (
      await firebase
        .database()
        .ref(`/doctors`)
        .child(user.uid)
        .once("value")
    ).val();
    if (doctor == null) {
      await firebase
        .auth()
        .signOut()
        .then(() => {
          commit("setUser", null);
        })
        .catch(error => {
          commit("setError", error.message);
        });
    }
  },
  signOutAction({ commit }) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        commit("setUser", null);
      })
      .catch(error => {
        commit("setError", error.message);
      });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
